The page of webhook subscription replays and their corresponding cursors.
